import TriPanel from '@/types/components/TriPanel.interface'
import Vue from 'vue'

interface State {
    triPanels: Object
}

const defaults = () => {
    return {
        triPanels: {}
    }
}
export default {
    state: defaults(),
    mutations: {
        triPanelSet(state: State, panel: TriPanel): void {

            const exists = state.triPanels[panel.id]

            if (exists) return

            Vue.set(state.triPanels, panel.id, panel)
        }
    },
    actions: {},
    getters: {
        triPanel: (state: State) => (id: string): TriPanel => {
            const iList = state.triPanels[id]
            return iList
        }
    }
}
